/**
 * drl-video-popup JS
 */

import $ from 'jquery';

Drupal.behaviors.drl_video_popup = {
  attach() {
    $(document).ready(function VideoPopup() {
      $('.img_sec .vid').on('click', function VideoPopupOpen() {
        let iframeSrc = $(this)
          .children('iframe')
          .attr('src');
        const iframe = $('.video-popup');
        const iframeVideo = $('.video-popup iframe');
        const closeBtn = $('.close-video');
        iframeSrc += '?autoplay=1&rel=0';

        // change the video source with the clicked one
        $(iframeVideo).attr('src', iframeSrc);
        $(iframe)
          .fadeIn()
          .addClass('show-video');

        $(document).on('click', function VideoPopupClose(e) {
          if ($(iframe).is(e.target) || $(closeBtn).is(e.target)) {
            $(iframe)
              .fadeOut()
              .removeClass('show-video');
            $(iframeVideo).attr('src', '');
          }
        });
      });
    });
  },
};
